import React from 'react';
import { SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

interface WidgetTitleProps {
  /**
   * Horizontal alignment of the widget title
   */
  alignment: string;
  /**
   * Represents the title that'll be displayed on adding widget or if no other option is selected
   */
  defaultTitle: string | React.ReactNode;
  /**
   * Title that is derived from the settings state
   */
  settingsTitle: string;
  /**
   * Custom title text to be displayed if the custom title option is selected
   */
  customTitle: string;
  /**
   * Styles for overriding default style
   */
  style?: SxProps<Theme>;
  /**
   * The query title to be displayed as the title if the widget query option is selected
   */
  widgetQueryTitle?: string;
  // Deprecated and no longer functional - use widgetQueryTitle instead:
  widgetQuery?: any;
  /**
   * Array list of ❗️widget specific❗️ title options objects that can only be dynamically defined in the widget component file.
   * @example [{ 'x-axis': trendData?.xLabel ?? '' }, ...];
   */
  widgetTitleOptions?: Record<string, string | undefined>[];
}

export default function WidgetTitle(props: WidgetTitleProps) {

  const dynamicWidgetTitle = () => {
    // Show default title by default
    if (props.settingsTitle === undefined || props.settingsTitle === 'default') {
      return props.defaultTitle;
    }

    // Show custom title - let the user allow the custom text field to be blank
    if (props.settingsTitle === 'custom') {
      if (props.customTitle === '') {
        return '';
      } else {
        return props.customTitle;
      }
    }

    if (props.settingsTitle !== 'custom') {
      // If title is set to use the query title
      if (props.settingsTitle === 'query' && props.widgetQueryTitle !== undefined) {
        return props.widgetQueryTitle;
      } else if (props.settingsTitle === 'query+title') {
        let title = props.defaultTitle;
        if (props.widgetQueryTitle !== undefined) {
          title = (<span>{title} - {props.widgetQueryTitle}</span>);
        }
        return title;
      } else {
      // If title is set to use the widget specific titles from props.widgetTitleOptions
        let obj = props.widgetTitleOptions?.find(item => {
          return Object.keys(item)[0] === props.settingsTitle;
        }) ?? {};

        return obj?.[props.settingsTitle];
      }
    }
  };

  const defaultStyle = { fontSize: "1.2rem", p: 2, pt: 1, pb: 0, textAlign: props.alignment };
  const displayTitle = dynamicWidgetTitle();

  return (
    <>
      {displayTitle && <Typography sx={{...defaultStyle, ...props.style} as SxProps<Theme>} variant="subtitle2">
          {displayTitle}
        </Typography>
      }
    </>
  )
}